<template>
  <div class="container">
    <div class='nav'>
      <div class='left'>
        <router-link to="/classlist">
          <img class='left-logo' src="@/assets/images/back.png" alt="logo" />
        </router-link>
      </div>
    </div>
    <div id="user-center">
      <div class="left">
        <ul>
          <router-link 
          tag="li" 
          to="/user/userinfo" 
          active-class="li-active" >个人资料</router-link>
          <!-- <router-link 
          tag="li" 
          to="/user/starcurr" 
          active-class="li-active" >星币</router-link> -->
          <router-link 
          tag="li" 
          to="/user/setting" 
          active-class="li-active" >设置</router-link>
        </ul>
      </div>
      <div class="right">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserCenter",
  components: {
  },
  data () {
    return {
      isClickBool: 1
    }
  },
  created () {
    // console.log(this.$route.path)
    
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.nav{
  width: 100%;
  height: 100px;
  position: relative;
  font-size: 15px;
  .left{
    // padding: 12px 0 0 22px;
    // display: flex;
    width: 180px;
    position: absolute;
    left: 22px;
    top: 12px;
    .left-logo{
      width: 80px;
      /* height: 58px; */
    }
    .left-qrcode{
      position: absolute;
      left: 200px;
      top: 12px;
    }
    .left-curr{
      width: 100px;
      height: 58px;
      background: url('~@/assets/images/get_star_cur.png') no-repeat;
      background-size: 100%;
      margin-left: 28px;
      color: #fff;
      cursor: pointer;
      &:hover{
        background: url('~@/assets/images/get_star_cur_hover.png') no-repeat;
        background-size: 100%;
      }
      .curr-text{
        margin: 34px 0 0 43px;
      }
    }
  }
  .right{
    position: absolute;
    right: 20px;
    top: 12px;
    .right-btn1{
      width: 75px;
      height: 40px;
      background: url('~@/assets/images/works.png') no-repeat;
      background-size: 100%;
      cursor: pointer;
      &:hover{
        background: url('~@/assets/images/works_hover.png') no-repeat;
        background-size: 100%;
      }
      .btn-text{
        color: #fff;
        margin: 14px 0 0 30px;
      }
    }
    .right-btn2{
      width: 180px;
      height: 70px;
      background: url('~@/assets/images/personInfo.png') no-repeat;
      background-size: contain;
      margin: 7px 0 0 60px;
      cursor: pointer;
      position: relative;
      /* &:hover{
         background: url('~@/assets/images/my_hover.png') no-repeat;
         background-size: 100%;
       } */
      .btn-text{
        color: #fff;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        position: absolute;
        left: 73px;
        top: 20px;
      }
    }
  }
}
#user-center{
  width: 1080px;
  min-height: 350px;
  margin: 70px auto 0px;
  display: flex;
  position: relative;
  .left{
    width: 220px;
    ul{
      padding: 20px;
      /* background: url("~@/assets/images/my_nav_bg.png") no-repeat;
      background-size: 100% 100%; */
      background: #AAECFF;
      border-radius: 20px;
      li{
        height: 80px;
        line-height: 80px;
        font-size: 18px;
        color: #363636 ;
        text-align: center;
        border-bottom: 1px solid #6DC2FF;
        position: relative;
        cursor: pointer;
        &:hover{
          color: #0088E8;
        }
        &:last-child{
          border: none;
        }
        img{
          width: 15px;
          height: 20px;
          position: absolute;
          top: 30px;
          right: 15px;
        }
      }
      .li-active{
        color: #0088E8;
      }
    }
  }
  .right{
    width: 820px;
    min-height: 350px;
    background: #F2F6F7;
    border: 10px solid #AAECFF;
    border-radius: 22px;
    padding: 20px;
    margin-left: 30px;
  }
}

/*  适配ipad端 */
/*竖屏 css*/
/* @media only screen and (min-width: 768px) and (max-width:1024px) and (orientation: portrait) {
  #user-center{
     width: 670px!important;
     margin: 70px 30px 0px 30px!important;
   }
} */
 /*横屏 css*/
/* @media only screen and (min-width: 768px) and (max-width:1024px) and (orientation: landscape) {
   #user-center{
     width: 880px!important;
     margin: 50px 30px 0px 30px!important;
   }
} */
</style>

